module.exports = __webpack_public_path__ + "static/media/notes.82bdc907.png";